import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import WarningTriangle from "./../assets/warning_triangle.png";
import LowRisk from "./../assets/LowRisk.png";
import "./DemoStyling.css";
import Settings from "../settings";
import { randDelay, UNLVDate} from "../../utils";
import "../../App.css";
import { resumeGame, pauseGame } from "../Game";

export default function AlertDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [showSettings, setShowSettings] = React.useState(false);
  const [showButtons, setShowButtons] = React.useState(true);
  const [disabled, setDisabled] = React.useState(true);

  // Low Fear / Low Efficacy

  // Changes made here to try and fix the game breaking
  const handleClickOpen = () => {
    setOpen(true);
    const msn_start_time = UNLVDate();
    localStorage.setItem("msn_start_time", msn_start_time);
    if (randDelay === 1) { pauseGame(); }
    displayButtons();
    enableButtonHandler();
  };

  const enableButtonHandler = (event) => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
      console.log("Buttons enabled");
    }, 5000);
  };

  const handleClose = () => {
    setOpen(false);
    if (randDelay === 1) { resumeGame(); }
  };

  const someFun = () => {
    handleClickOpen();
  };

  function clickedButton(clickYes){
    localStorage.setItem("time_respond", UNLVDate())
    setShowSettings(clickYes);
    setOpen(false);
    if (clickYes) {
      localStorage.setItem("msn_accept", "1")
    } else {
      localStorage.setItem("msn_accept", "0")
      handleClose()
    }
  }
  const time_func = () => {
    var time = UNLVDate();
    localStorage.setItem("key", time);
  };
  const displayButtons = () => {
    setTimeout(() => {
      setShowButtons(true);
      console.log("Buttons showing");
    }, 5000);
  };

  useEffect(() => {
    if (props.term) {
      return () => someFun();
    }
  }, [props.term]);

  useEffect(() => {
    if (!props.done) {
      const timer = setTimeout(() => {
        handleClickOpen();
      }, (randDelay !== 1) ? 0 : 150000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div>
      <Dialog
        disableBackdropClick
        open={open}
        onClose={handleClose}
        onEnter={time_func}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div>
          <div className="dialog__header_low">
            <DialogTitle  
            id="alert-dialog-title"
            classes={{root: "main__title"}}>
              { <div className = "main__inner_content">
                  <div className = "main__inner_content-first">
                    <h1 style={{ color: "black"
                    }}><b>TaskProtector Mobile Security</b></h1>
                    <h4>Potential security concern identified</h4>
                  </div>
                  <div>
                    <img src={WarningTriangle} alt="WarningTriangle" className="img"/>
                  </div>
                </div>}
            </DialogTitle>
          </div>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <img src={LowRisk} alt="risk_image" className="risk__image"/>

              <p style={{ fontSize: 14, textAlign: "justify", color:"darkslategray"}} className="avoid__border">
                This app is trying to access the device ID stored in your mobile device.
              </p>
              <br></br>
              <p style={{ fontSize: 14, textAlign: "justify", color:"darkslategray"}} >
                <b>Threat: </b>Misuse of this information can lead to contextual advertising, customer segmentation, or consumer profiling  (<b>10% possibility</b>).
              </p>
              <br></br>

              <div className="recommended__borders">
                <p style={{ fontSize: 14, textAlign: "center", color:"darkslategray"}}><b>Recommended Action</b></p>
                <ul style={{ fontSize: 14, textAlign: "justify", color:"darkslategray", marginLeft: "1rem"}}>
                  <li> &#8226;    Check your "security settings" to ensure your device is protected.</li>
                  <li> &#8226;    Denying access could be helpful  (<b>10% success rate</b>).</li>
                </ul>
              </div>

              <br></br>
              <p
                style={{
                  fontSize: 14,
                  color: "black",
                  textAlign: "center",
                }}
              >
                <b><b>Go to the security setting page to deny access?</b></b>
              </p>
            </DialogContentText>
          </DialogContent>
        </div>
        {showButtons && (
          <div className="button-flex">
            <div>
            <Button
                  variant="contained"
                  style={{ fontSize: 10, paddingRight: 10}}
                  onClick={() => {clickedButton(true)}}
                  color="error"
                  disabled={disabled}
                  onChange={enableButtonHandler}
                >
                  Yes
                </Button>
            </div>
            <div>
            <Button
                  variant="contained"
                  style={{ fontSize: 10, paddingRight: 10}}
                  onClick={() => {clickedButton(false)}}
                  color="error"
                  disabled={disabled}
                  onChange={enableButtonHandler}
                >
                  No
                </Button>
            </div>
          </div>
        )}
      </Dialog>
      {showSettings && <Settings />}
    </div>
  );
}
